var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4687_10167)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4687_10167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2863 23.7144H13.7148",
    stroke: "#18202F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7148 15.1426H22.2863",
    stroke: "#18202F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7148 19.4287H22.2863",
    stroke: "#18202F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5798 8.59413C23.1256 9.6587 22.2964 10.8571 21.1 10.8571H14.843C13.6627 10.8571 12.8328 9.68728 13.3544 8.62847C14.4767 6.35018 15.9148 4.68474 18.0003 2.28564C20.0013 4.67712 21.4223 6.33662 22.5798 8.59413Z",
    fill: "#B6C0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5719 24.1408C8.17455 24.1408 10.2844 22.0311 10.2844 19.4283C10.2844 16.8257 8.17455 14.7158 5.5719 14.7158C2.96924 14.7158 0.859375 16.8257 0.859375 19.4283C0.859375 22.0311 2.96924 24.1408 5.5719 24.1408Z",
    fill: "#B6C0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46008 9.09683C1.5513 9.91972 2.21012 10.5783 3.03263 10.6729C3.85521 10.7675 4.70365 10.8571 5.57087 10.8571C6.43809 10.8571 7.28653 10.7675 8.10911 10.6729C8.93162 10.5783 9.59044 9.91972 9.68166 9.09683C9.7724 8.27832 9.85658 7.43416 9.85658 6.57136C9.85658 5.70854 9.7724 4.86439 9.68166 4.04589C9.59044 3.223 8.93162 2.56443 8.10911 2.46983C7.28653 2.37523 6.43809 2.28564 5.57087 2.28564C4.70365 2.28564 3.85521 2.37523 3.03263 2.46983C2.21012 2.56443 1.5513 3.223 1.46008 4.04589C1.36934 4.86439 1.28516 5.70854 1.28516 6.57136C1.28516 7.43416 1.36934 8.27832 1.46008 9.09683Z",
    fill: "#B6C0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5798 8.59413C23.1256 9.6587 22.2964 10.8571 21.1 10.8571H14.843C13.6627 10.8571 12.8328 9.68728 13.3544 8.62847C14.4767 6.35018 15.9148 4.68474 18.0003 2.28564C20.0013 4.67712 21.4223 6.33662 22.5798 8.59413Z",
    stroke: "#18202F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5719 24.1408C8.17455 24.1408 10.2844 22.0311 10.2844 19.4283C10.2844 16.8257 8.17455 14.7158 5.5719 14.7158C2.96924 14.7158 0.859375 16.8257 0.859375 19.4283C0.859375 22.0311 2.96924 24.1408 5.5719 24.1408Z",
    stroke: "#18202F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46008 9.09683C1.5513 9.91972 2.21012 10.5783 3.03263 10.6729C3.85521 10.7675 4.70365 10.8571 5.57087 10.8571C6.43809 10.8571 7.28653 10.7675 8.10911 10.6729C8.93162 10.5783 9.59044 9.91972 9.68166 9.09683C9.7724 8.27832 9.85658 7.43416 9.85658 6.57136C9.85658 5.70854 9.7724 4.86439 9.68166 4.04589C9.59044 3.223 8.93162 2.56443 8.10911 2.46983C7.28653 2.37523 6.43809 2.28564 5.57087 2.28564C4.70365 2.28564 3.85521 2.37523 3.03263 2.46983C2.21012 2.56443 1.5513 3.223 1.46008 4.04589C1.36934 4.86439 1.28516 5.70854 1.28516 6.57136C1.28516 7.43416 1.36934 8.27832 1.46008 9.09683Z",
    stroke: "#18202F",
    strokeWidth: 1.71429
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4687_10167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4687_10167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreActive);
export default __webpack_public_path__ + "static/media/exploreActive.1e7429e04f5696fd65e4874d9fd6eb21.svg";
export { ForwardRef as ReactComponent };